export enum StorageKey {
  TOKEN = 'token',
  id_token = 'id_token',
  access_token = 'access_token',
  expiresAt = 'expiresAt',
  url = 'url',
}
